import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
    title?: string;
    message?: string;
    className?: string;
}

export const ErrorState = ({
    title,
    message,
    className = '',
}: ErrorStateProps) => {
    const { t } = useTranslation();

    const defaultTitle = t('errors.internalServerError');

    return (
        <div
            className={`flex flex-col items-center justify-center h-full w-full text-center gap-12 ${className}`}
        >
            <div className="w-36 h-36 flex items-center justify-center bg-red-50 rounded-full">
                <ExclamationTriangleIcon className="w-16 h-16 text-red-500" />
            </div>
            <div className="flex flex-col items-center justify-center gap-6">
                <span className="text-2xl text-gray-600">
                    {title || defaultTitle}
                </span>
                {message && <p className="text-gray-500 max-w-md">{message}</p>}
            </div>
        </div>
    );
};
